/* OverDMA Bundle Builder — launcher.
   Draws the "Over" bubble and its tip on every page and loads the quiz itself
   (assets/overdma-quiz.js, about 130 KB) only when it is needed: the first tap on
   the bubble, a #bundle link, or the quiz page. Markup, texts and styles mirror
   buildLauncher() and the launcher part of QUIZ_CSS in overdma-quiz.js: change both. */
(function () {
  'use strict';
  if (window.__overdmaBundleLoaded || window.__overdmaLauncherLoaded) return;
  window.__overdmaLauncherLoaded = true;
  var tag = document.currentScript || document.querySelector('script[data-quiz-src]');
  var src = tag && tag.getAttribute('data-quiz-src');
  if (!src) return;

  var MASCOT = 'https://cdn.shopify.com/s/files/1/0621/1380/8478/files/Photoroom_20260622_150625.png?v=1782802504&width=240';
  var TEXT = {
    launcherAria: 'Open the OverDMA bundle assistant',
    closeAria: 'Close',
    hideAria: 'Hide the assistant',
    bubbleTitle: 'Not sure which bundle?',
    bubbleMsg: "Hi, I'm Over, the OverDMA assistant. Answer 6 quick questions and I'll match you with the right DMA setup.",
    bubbleCta: 'Find my bundle'
  };
  // Modal layers the bubble and its tip stay out of (contract C3): purchase sheets, drawers, dialogs.
  var LAYERS = 'dialog[open],quick-add-modal[open],product-modal[open],modal-dialog[open],.cart-notification.active,cart-drawer.active,'
    + '.header__search details[open],header-drawer details[open],menu-drawer details[open]';
  var CSS = '#overdma-widget{--g:#E8C56C;--gd:#C29A45;--dark:#0C0D0F;--card:#191A1E;--line:#2A2B30;font-family:var(--font-body-family,system-ui),system-ui,sans-serif;line-height:1.45;-webkit-tap-highlight-color:transparent;}'
    + '#overdma-widget *{box-sizing:border-box;}'
    + '.ovw-bub,.ovw-tip,.ovw-tip-x,.ovw-dismiss{touch-action:manipulation;}'
    /* under Dawn's modal layers (quick add 101, drawers 1000, the top layer), above the sticky header (3-4) */
    + '.ovw-launch{position:fixed;right:calc(22px + env(safe-area-inset-right,0px));bottom:calc(22px + env(safe-area-inset-bottom,0px));z-index:99;display:flex;align-items:flex-end;flex-direction:row-reverse;gap:12px;'
    + 'transform-origin:100% 100%;animation:ovwIn .4s cubic-bezier(.16,1,.3,1) backwards;transition:opacity .2s ease .1s,transform .2s cubic-bezier(.16,1,.3,1) .1s,visibility 0s linear 0s;}'
    /* a modal task is open: fade into the corner, out of the hit test and of the focus order */
    + 'body:has(' + LAYERS + ') .ovw-launch{opacity:0;transform:scale(.9);visibility:hidden;pointer-events:none;transition:opacity .15s ease,transform .15s ease,visibility 0s linear .15s;}'
    /* only the bubble, the tip and the x take taps: the empty rest of the fixed box lets them through to the page */
    + '.ovw-launch{pointer-events:none;}.ovw-launch>*{pointer-events:auto;}'
    + 'body:has(' + LAYERS + ') .ovw-launch>*{pointer-events:none;}'
    /* keyboard scrolling stops focused controls above the bubble (66px + 22px from the edge) */
    + 'html:has(#overdma-widget .ovw-launch:not(.ovw-hidden)){scroll-padding-bottom:calc(66px + 22px + 1.6rem + env(safe-area-inset-bottom,0px));}'
    + '.ovw-bub{position:relative;width:66px;height:66px;border-radius:50%;border:none;cursor:pointer;padding:0;background:radial-gradient(circle at 50% 38%,#2A2B30,#161618);box-shadow:0 8px 28px rgba(0,0,0,.45),0 0 0 1px rgba(232,197,108,.35);transition:transform var(--odma-press-out,.2s) var(--odma-ease,cubic-bezier(.16,1,.3,1)),box-shadow .2s;}'
    + '@media(hover:hover){.ovw-bub:hover{transform:translateY(-3px) scale(1.04);box-shadow:0 12px 34px rgba(0,0,0,.55),0 0 0 2px rgba(232,197,108,.6);}}'
    + '.ovw-bub:active{transform:scale(.92);transition-duration:var(--odma-press-in,.08s);}'
    + '.ovw-bub[aria-busy="true"]{cursor:progress;opacity:.75;}'
    /* one attention beat, then rest: two rings, three pings, one wave (and one more when the tip shows) */
    + '.ovw-bub img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;padding:6px;z-index:2;transform-origin:50% 58%;animation:ovwWiggle .8s ease-in-out .6s;}'
    + '.ovw-bub.ovw-hey img{animation:ovwHey .8s ease-in-out .15s;}'
    + '.ovw-bub::before,.ovw-bub::after{content:"";position:absolute;inset:0;border-radius:50%;border:2px solid var(--g);opacity:0;pointer-events:none;animation:ovwWave 3s ease-out 2;}'
    + '.ovw-bub::after{animation-delay:.5s;}'
    + '.ovw-ping{position:absolute;top:4px;right:4px;width:13px;height:13px;border-radius:50%;background:var(--g);border:2px solid #0C0D0F;z-index:3;}'
    + '.ovw-ping::after{content:"";position:absolute;inset:-2px;border-radius:50%;background:var(--g);opacity:0;animation:ovwPing 1.8s ease-out 3;}'
    /* hides the bubble for the session: a badge just off the bubble's top-left edge, its 44px target
       reaches up and left, away from the bubble, so no tap on the bubble lands on it */
    + '.ovw-dismiss{position:absolute;right:54px;bottom:54px;z-index:4;width:22px;height:22px;padding:0;border-radius:50%;border:1px solid rgba(255,255,255,.2);background:#0C0D0F;color:#C9C9CE;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.5);'
    + 'transition:color .15s,border-color .15s,transform var(--odma-press-out,.2s) var(--odma-ease,cubic-bezier(.16,1,.3,1));}'
    + '.ovw-dismiss::before{content:"";position:absolute;inset:-20px -4px -4px -20px;border-radius:50%;}'
    + '.ovw-dismiss svg{width:10px;height:10px;}'
    + '@media(hover:hover){.ovw-dismiss:hover{color:#fff;border-color:rgba(255,255,255,.45);}}'
    + '.ovw-dismiss:active{transform:scale(.9);transition-duration:var(--odma-press-in,.08s);}'
    /* one close button at a time: while the tip shows, its own x closes it */
    + '.ovw-tip:not(.ovw-hidden)~.ovw-dismiss:not(:focus){display:none;}'
    /* the tip is a floating material over the page: translucent, blurred, slightly brighter text */
    + '.ovw-tip{position:relative;max-width:248px;background:rgba(25,26,30,.86);-webkit-backdrop-filter:blur(20px) saturate(150%);backdrop-filter:blur(20px) saturate(150%);border:1px solid rgba(255,255,255,.1);border-radius:14px 14px 4px 14px;padding:13px 42px 13px 15px;'
    + 'box-shadow:inset 0 1px 0 rgba(255,255,255,.08),0 10px 30px rgba(0,0,0,.4);transform-origin:100% 100%;animation:ovwTipIn .35s cubic-bezier(.16,1,.3,1) backwards;cursor:pointer;}'
    + '.ovw-tip-t{font-size:1.35rem;font-weight:600;color:#fff;margin-bottom:2px;text-wrap:balance;}'
    + '.ovw-tip-m{font-size:1.25rem;color:#C9C9CE;line-height:1.4;}'
    + '.ovw-tip-x{position:absolute;top:2px;right:2px;width:36px;height:36px;min-width:44px;min-height:44px;display:flex;align-items:center;justify-content:center;background:none;border:none;color:#B5B5B5;font-size:2rem;cursor:pointer;line-height:1;padding:0;border-radius:50%;}'
    + '@media(hover:hover){.ovw-tip-x:hover{color:#fff;}}'
    + '.ovw-tip-cta{display:inline-flex;align-items:center;gap:5px;margin-top:8px;background:var(--g);color:#0C0D0F;font-size:1.2rem;font-weight:700;padding:5px 12px;border-radius:7px;border:0;cursor:pointer;font-family:inherit;min-height:44px;text-align:left;'
    + 'transition:transform var(--odma-press-out,.2s) var(--odma-ease,cubic-bezier(.16,1,.3,1)),filter var(--odma-press-out,.2s);}'
    + '.ovw-tip-cta:active{transform:scale(var(--odma-press-scale,.97));filter:brightness(.9);transition-duration:var(--odma-press-in,.08s);}'
    + '.ovw-tip button:focus-visible,.ovw-dismiss:focus-visible{outline:2px solid #f5db91;outline-offset:3px;}'
    + '.ovw-tip-cta .ovq-ico{width:14px;height:14px;flex:none;}'
    + '.ovw-hidden{display:none !important;}'
    + '@keyframes ovwIn{from{opacity:0;transform:scale(.6);}}'
    + '@keyframes ovwTipIn{from{opacity:0;transform:translate(8px,4px) scale(.96);}}'
    + '@keyframes ovwPing{0%{transform:scale(1);opacity:.6;}100%{transform:scale(2.4);opacity:0;}}'
    + '@keyframes ovwWave{0%{transform:scale(.92);opacity:.55;}55%{transform:scale(1.85);opacity:0;}100%{transform:scale(1.85);opacity:0;}}'
    + '@keyframes ovwWiggle{0%,100%{transform:rotate(0);}18%{transform:rotate(-8deg);}36%{transform:rotate(7deg);}54%{transform:rotate(-5deg);}72%{transform:rotate(3deg);}}'
    + '@keyframes ovwHey{0%,100%{transform:rotate(0);}18%{transform:rotate(-8deg);}36%{transform:rotate(7deg);}54%{transform:rotate(-5deg);}72%{transform:rotate(3deg);}}'
    + '@media(max-width:520px){.ovw-launch{right:calc(16px + env(safe-area-inset-right,0px));bottom:calc(16px + env(safe-area-inset-bottom,0px));}.ovw-tip{max-width:230px;}}'
    + '@supports not ((backdrop-filter:blur(1px)) or (-webkit-backdrop-filter:blur(1px))){.ovw-tip{background:#191A1E;}}'
    + '@media(prefers-reduced-transparency:reduce){.ovw-tip{background:#191A1E;-webkit-backdrop-filter:none;backdrop-filter:none;}}'
    + '@media(prefers-contrast:more){.ovw-tip{background:#191A1E;-webkit-backdrop-filter:none;backdrop-filter:none;border-color:rgba(255,255,255,.5);}.ovw-tip-m{color:#E4E4E7;}'
    + '.ovw-bub{box-shadow:0 8px 28px rgba(0,0,0,.45),0 0 0 2px var(--g);}.ovw-dismiss{border-color:rgba(255,255,255,.6);color:#fff;}}'
    /* reduced motion: no rings, waves, scales or slides; colour and opacity changes still fade (150 ms) */
    + '@media(prefers-reduced-motion:reduce){#overdma-widget *,#overdma-widget *::before,#overdma-widget *::after{animation:none !important;transition-property:color,background-color,border-color,opacity;transition-duration:.15s;}'
    + 'body:has(' + LAYERS + ') .ovw-launch{transform:none;}.ovw-bub:hover,.ovw-bub:active,.ovw-dismiss:active,.ovw-tip-cta:active{transform:none;}.ovw-bub:active,.ovw-dismiss:active{filter:brightness(.8);}}';

  // Phones, and touch screens of any width (tablets, phones held sideways): the bubble waits for the
  // first scroll, the tip waits for the page to be still and hides itself. Same query in overdma-quiz.js.
  var PHONE = '(max-width:749px), (hover:none) and (pointer:coarse)';
  var phone = function () { return Boolean(window.matchMedia) && window.matchMedia(PHONE).matches; };
  var loading = false;
  var widget, launch, bubble, tip, tipTimer, tipWait = false;

  // Loads the quiz. open: the shopper asked for it (a tap), so it opens as soon as it runs.
  function load(open) {
    if (open) window.__overdmaOpenOnLoad = true;
    if (loading || window.__overdmaBundleLoaded) return;
    loading = true;
    if (bubble) bubble.setAttribute('aria-busy', 'true');
    var script = document.createElement('script');
    script.src = src;
    script.onerror = function () {
      loading = false;
      if (bubble) bubble.removeAttribute('aria-busy');
      // Without the quiz, its page is the next best thing.
      if (window.__overdmaOpenOnLoad) { window.__overdmaOpenOnLoad = false; location.href = '/pages/build-your-setup'; }
    };
    document.head.appendChild(script);
  }
  // Same links as shouldAutoOpen() in overdma-quiz.js.
  function wantsQuiz() {
    var h = (location.hash || '').toLowerCase();
    var q = (location.search || '').toLowerCase();
    return h === '#bundle' || h === '#armar' || /[?&](bundle|builder|armar)(=|&|$)/.test(q);
  }
  var quizPage = /\/pages\/build-your-setup\/?$/.test(location.pathname || '');

  function showTip() {
    if (!tip) return;
    // Never over a purchase sheet or a dialog (the bubble is hidden then): try again later.
    if (document.querySelector(LAYERS)) { tipTimer = setTimeout(showTip, 4500); return; }
    // Keyboard focus resting on the page: the tip could cover it, so try again later.
    if (keyFocus()) { tipTimer = setTimeout(showTip, 4500); return; }
    tipWait = false;
    tip.classList.remove('ovw-hidden');
    bubble.classList.add('ovw-hey');
    try { sessionStorage.setItem('ovw_tip_seen', '1'); } catch (e) {}
    if (phone()) tipTimer = setTimeout(hideTip, 7000);
  }
  function hideTip() {
    tipWait = false;
    if (tip) tip.classList.add('ovw-hidden');
    try { sessionStorage.setItem('ovw_tip_seen', '1'); } catch (e) {}
  }
  // Touch: every scroll starts the tip's 4.5 s again, so it shows once the page is still, not under a moving thumb.
  function tipStill() {
    if (!tipWait) { document.removeEventListener('scroll', tipStill, true); return; }
    clearTimeout(tipTimer);
    tipTimer = setTimeout(showTip, 4500);
  }
  // A control on the page has keyboard focus (the tip must not open over it).
  function keyFocus() {
    var a = document.activeElement;
    if (!a || a === document.body || widget.contains(a)) return false;
    try { return a.matches(':focus-visible'); } catch (e) { return false; }
  }
  // The tip is on screen: shown, still this page's (the quiz rebuilds the widget), no modal layer over it.
  function tipOpen() {
    return Boolean(tip) && !tip.classList.contains('ovw-hidden') && widget.contains(tip) && !document.querySelector(LAYERS);
  }
  // The bubble's own x: gone for this session; the quiz stays one link away (#bundle, the quiz page).
  function hideBubble() {
    clearTimeout(tipTimer);
    hideTip();
    launch.classList.add('ovw-hidden');
    try { sessionStorage.setItem('ovw_bubble_hidden', '1'); } catch (e) {}
  }
  function build() {
    widget = document.getElementById('overdma-widget');
    if (!widget) { widget = document.createElement('div'); widget.id = 'overdma-widget'; document.body.appendChild(widget); }
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);
    widget.innerHTML = '<div class="ovw-launch">'
      + '<button class="ovw-bub" aria-label="' + TEXT.launcherAria + '"><img src="' + MASCOT + '" alt="Over" width="66" height="66" decoding="async"/><span class="ovw-ping"></span></button>'
      + '<div class="ovw-tip ovw-hidden">'
      + '<button class="ovw-tip-x" aria-label="' + TEXT.closeAria + '">&times;</button>'
      + '<div class="ovw-tip-t">' + TEXT.bubbleTitle + '</div>'
      + '<div class="ovw-tip-m">' + TEXT.bubbleMsg + '</div>'
      + '<button type="button" class="ovw-tip-cta">' + TEXT.bubbleCta + ' <svg class="ovq-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/></svg></button>'
      + '</div>'
      + '<button type="button" class="ovw-dismiss" aria-label="' + TEXT.hideAria + '"><svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M2 2l6 6M8 2L2 8"/></svg></button>'
      + '</div>';
    launch = widget.querySelector('.ovw-launch');
    bubble = widget.querySelector('.ovw-bub');
    tip = widget.querySelector('.ovw-tip');
    bubble.addEventListener('click', function () { load(true); });
    tip.addEventListener('click', function (e) { if (!e.target.closest('.ovw-tip-x')) load(true); });
    widget.querySelector('.ovw-tip-x').addEventListener('click', function (e) { e.stopPropagation(); hideTip(); });
    widget.querySelector('.ovw-dismiss').addEventListener('click', hideBubble);
    // iOS Safari shows :active (the press state) only on elements with a touch listener.
    widget.addEventListener('touchstart', function () {}, { passive: true });
    // The tip must not hide the keyboard focus: Escape closes it, and so does keyboard focus moving to the
    // page (a mouse click keeps it). Only while it shows; Escape still reaches the quiz and Dawn's dialogs.
    document.addEventListener('keydown', function (e) {
      if ((e.key !== 'Escape' && e.key !== 'Esc') || !tipOpen()) return;
      var back = tip.contains(document.activeElement);
      hideTip();
      if (back) bubble.focus();
    });
    document.addEventListener('focusin', function (e) {
      if (!tipOpen() || widget.contains(e.target)) return;
      try { if (e.target.matches(':focus-visible')) hideTip(); } catch (err) {}
    });

    var dismissed = false;
    try { dismissed = sessionStorage.getItem('ovw_bubble_hidden') === '1'; } catch (e) {}
    if (dismissed) { launch.classList.add('ovw-hidden'); return; }

    // The tip shows once per session, 4.5 s after the bubble. On phones and touch screens (PHONE) the bubble
    // waits until the shopper scrolls past the first screen (it covered the hero's game card).
    var seen = false;
    try { seen = sessionStorage.getItem('ovw_tip_seen') === '1'; } catch (e) {}
    var armTip = function () {
      if (seen) return;
      try { if (sessionStorage.getItem('ovw_tip_seen') === '1') return; } catch (e) {} // the quiz may have been used since
      tipTimer = setTimeout(showTip, 4500);
      // capture: scrolling inside a lane (the A-Z letters) counts too
      if (phone()) { tipWait = true; document.addEventListener('scroll', tipStill, { capture: true, passive: true }); }
    };
    if (phone()) {
      launch.classList.add('ovw-hidden');
      var reveal = function () {
        if ((window.pageYOffset || document.documentElement.scrollTop || 0) <= window.innerHeight * 0.6) return;
        launch.classList.remove('ovw-hidden');
        window.removeEventListener('scroll', reveal);
        armTip();
      };
      window.addEventListener('scroll', reveal, { passive: true });
      reveal();
    } else {
      armTip();
    }
  }

  function boot() {
    if (quizPage || document.getElementById('overdma-quiz-inline') || wantsQuiz()) return load(false);
    build();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('hashchange', function () { if (wantsQuiz()) load(false); });
  // Theme editor: a section that holds the inline quiz was (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#overdma-quiz-inline')) load(false);
  });
})();
